import { render, staticRenderFns } from "./PermissionsUserById.vue?vue&type=template&id=79a32499&scoped=true&"
import script from "./PermissionsUserById.vue?vue&type=script&lang=js&"
export * from "./PermissionsUserById.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsUserById.vue?vue&type=style&index=0&id=79a32499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a32499",
  null
  
)

export default component.exports